import { render } from "./default.vue?vue&type=template&id=779860b5&scoped=true&ts=true"
import script from "./default.vue?vue&type=script&lang=ts"
export * from "./default.vue?vue&type=script&lang=ts"

import "./default.vue?vue&type=style&index=0&id=779860b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779860b5"]])

export default __exports__